import agent from '../agent';
import React, { useState } from 'react';
import MainHeader from '../components/Header';
import Sidebar from '../components/Sidebar';
import { connect } from 'react-redux';
import { APP_LOAD, LOGOUT, REDIRECT, API_BUILDER_LIMIT } from '../constants/actionTypes';
import { Route, Switch, Redirect } from 'react-router-dom';

import Login from '../layouts/views/login';
import Users from '../layouts/views/users';
import Report from '../layouts/views/report';
import Settings from '../layouts/views/settings';
import SearchResult from '../layouts/views/searchResult';
import SearchResultForeign from '../layouts/views/searchResultForeign';
// import ApiBuilder from '../layouts/views/apiBuilder';


import { store } from '../store';
import { push } from 'react-router-redux';

import { Layout, Divider, Pagination } from 'antd';
import 'antd/dist/antd.css';

const { Content } = Layout;
const TEST_URL = process.env.REACT_APP_TEST_URL;//'/test'
//const TEST_URL = ''

const mapStateToProps = state => {
  // console.log(state)

  return {
    appLoaded: state.common.appLoaded,
    appName: state.common.appName,
    currentUser: state.common.currentUser,
    redirectTo: state.common.redirectTo,
    settings: state.settings
  }
};

const mapDispatchToProps =  dispatch => ({
  onLoad:  (payload, token) => 
    dispatch({ type: APP_LOAD, payload: agent.Auth.current(token), token, skipTracking: false }),
  onLogout: () =>
    dispatch({ type: LOGOUT }),
  onRedirect: () =>
    dispatch({ type: REDIRECT }),
  getLimit: () =>
    dispatch({ type: API_BUILDER_LIMIT, payload: agent.ApiBuilder.getApiBuilderLimit() }),
});

const page_list = [
  "/login",
  TEST_URL+"/searchResultLocal", //temp for test
  TEST_URL+"/searchResultForeign",
  // "/apiBuilder",
  "/report",
  "/users",
  "/settings",
]

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      value1: null,
      value2: null,
      value3: null,
      size: 'small',
      totalPagesInTables: props.settings.settingPaginationTotal
    };
  }



  //Settings Page function Start
  onFinishSettings = (values) => {
    console.log('Success:', values);
    this.setState({
      totalPagesInTables: values.paginationTotal
    })
  };

  onFinishFailedSettings = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  //Settings Page function End




  handleChange = (e) => {
    console.log(e)
  }


  onFinish = (values) => {
    console.log('Success:', values);
    if ((values.value_1 !== undefined) && (values.value_2 !== undefined) && (values.value_3 !== undefined)) {
      this.setState({
        value1: values.value_1,
        value2: values.value_2,
        value3: values.value_3,
      })
    } else {
      this.setState({
        value1: null,
        value2: null,
        value3: null,
      })

    }
  };

  onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };


  handleClickMenu = (e) => { }


  handleClickMenuArrow = () => {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }


  handleClickExpendToggle = (e) => {
    this.setState({
      expendChecked: !this.state.expendChecked
    });
  };

  handleClickLogout = (e) => {
    this.props.onLogout()
  };

  componentWillReceiveProps(nextProps) {
    var { redirectTo, currentUser, location, history } = nextProps;
    
    if (TEST_URL && ["/searchResultLocal", "/searchResultForeign"].includes(location.pathname)){
      return
    }
    if (location.pathname  !== '/' && location.pathname !== TEST_URL+'/searchResultForeign'&& location.pathname !== TEST_URL+'/searchResultLocal') {
      if (!currentUser && history.action === 'POP'){
        store.dispatch(push('/login'));
        this.props.onRedirect();
      }
    }
    if (redirectTo) {
      if (redirectTo === '/report' && location.pathname === '/login') {

        const token = window.localStorage.getItem('jwt');
        // const token = window.localStorage.getItem('jwt');
        nextProps.onLoad(null, token);
      }
      store.dispatch(push(redirectTo));
      this.props.onRedirect();
    }
    if (nextProps.settings && this.props.settings.settingPaginationTotal !== nextProps.settings.settingPaginationTotal){
      this.setState({
        totalPagesInTables: nextProps.settings.settingPaginationTotal,
        twoFactorStatus: nextProps.settings.twoFactorStatus,
      });
    }

  }
  
  componentWillMount() {
    var token= window.localStorage.getItem('jwt');
    var refresh = window.localStorage.getItem('refresh');

    if (TEST_URL && ["/searchResultLocal", "/searchResultForeign"].includes(this.props.location.pathname)){
      return
    }
    // const token = window.localStorage.getItem('jwt');
    if (!page_list.includes(this.props.location.pathname)){
      store.dispatch(push('/'+this.props.location.search));
      this.props.onRedirect();
      return
    }
    
    if (this.props.location.pathname !== '/' && this.props.location.pathname !== TEST_URL+'/searchResultForeign' && this.props.location.pathname !== TEST_URL+'/searchResultLocal'){
      if (token) {
        agent.setToken(token, refresh);
      } else { 
          this.props.onLogout()
      }
      this.props.onLoad(null, token);            
    }
    
  }
  componentDidMount(){
    this.props.getLimit();
  }
  
  render() {
    var { location } = this.props;
    console.log(location)
    return (
      <div className="App">
        {/* <Spin tip="Loading..." size="large" style={{ color: "#000" }}> */}
        <Layout className="mainContainerLayout">
          {(!(location.pathname === '/' || location.pathname.includes('/login') || location.pathname.includes('/searchResult') || location.pathname.includes('/login_apibuilder') || location.pathname.includes('/apiBuilder'))) && <Sidebar
            collapsed={this.state.collapsed}
            location={location.pathname}
            handleClickMenuArrow={this.handleClickMenuArrow}
            handleClickMenu={this.handleClickMenu}
            handleClickLogout = {this.handleClickLogout}
            />}
          
          <Layout className="site-layout">
            <Content className="mainContainer" style={{margin:location.pathname == '/' || location.pathname.includes('/searchResultForeign') || location.pathname.includes('/searchResult') || location.pathname.includes('/apiBuilder')?0:'15px'}} role="main">
              <Switch>
                <Route exact path="/login" render={(props) => (<Login {...props} size={this.state.size} title="Companies Registry - Administration of API Builder" 
                  twoFactorStatus={this.state.twoFactorStatus}
                />)}
                />
                {/* <Route exact path="/searchResult" render={(props) => (<SearchResult {...props} */}
                {TEST_URL && <Route exact path="/searchResultLocal" render={(props)=>{window.location.href = "https://data.cr.gov.hk/Maintenance_EN.html"}} />}
                {TEST_URL && <Route exact path="/searchResultForeign" render={(props)=>{window.location.href = "https://data.cr.gov.hk/Maintenance_EN.html"}} />}
                <Route exact path={TEST_URL+"/searchResultLocal"} render={(props) => (<SearchResult {...props} title="Companies Registry - Registered Office Address of Live Local Companies"
                  handleChange={this.handleChange}
                  onFinishFailed={this.onFinishFailed}
                  onFinish={this.onFinish}
                  value1={this.state.value1}
                  value2={this.state.value2}
                  value3={this.state.value3}
                  size={this.state.size}
                  settingPaginationTotal={this.state.totalPagesInTables} />)}
                />
                {TEST_URL?<Route exact path="/" render={(props)=>{window.location.href = "https://data.cr.gov.hk/Maintenance_EN.html"}} />:
                  <Route exact path="/"><Redirect to={TEST_URL+"/searchResultLocal"+this.props.location.search} /></Route>
                }
                <Route exact path={TEST_URL+"/searchResultForeign"} render={(props) => (<SearchResultForeign {...props} title="Companies Registry - Principal Place of Business of Registered Non-Hong Kong Companies"
                  handleChange={this.handleChange}
                  onFinishFailed={this.onFinishFailed}
                  onFinish={this.onFinish}
                  value1={this.state.value1}
                  value2={this.state.value2}
                  value3={this.state.value3}
                  size={this.state.size}
                  settingPaginationTotal={this.state.totalPagesInTables} />)}
                />
                {/* <Route exact path="/apiBuilder" render={(props) => (<ApiBuilder {...props}
                  handleChange={this.handleChange}
                  onFinishFailed={this.onFinishFailed}
                  onFinish={this.onFinish}
                  value1={this.state.value1}
                  value2={this.state.value2}
                  value3={this.state.value3}
                  size={this.state.size}
                  settingPaginationTotal={this.state.totalPagesInTables} />)}
                /> */}
                <Route exact path="/report" render={(props) => (<Report {...props}
                  size={this.state.size}
                  handleChange={this.handleChange}
                  settingPaginationTotal={this.state.totalPagesInTables} />)}
                />
                <Route exact path="/users" render={(props) => (<Users {...props}
                  size={this.state.size}
                  settingPaginationTotal={this.state.totalPagesInTables} />)}
                />
                <Route exact path="/settings" render={(props) => (<Settings {...props}
                  onFinishSettings={this.onFinishSettings}
                  onFinishFailedSettings={this.onFinishFailedSettings}
                  settingPaginationTotal={this.state.totalPagesInTables}
                  size={this.state.size} />)}
                />
                {!TEST_URL && <Redirect to="/" />}
              </Switch>
            </Content>
          </Layout>
        </Layout>
        {/* </Spin> */}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// src/components/App.js